import React, { useState, useEffect } from "react";
import axios from "axios";
import MainNavbar from "../MainNavbar";
import { FaRegCalendarAlt, FaUser, FaStar, FaCalendarCheck } from "react-icons/fa";
import "./AstrologyConsultation.css";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const AstrologyConsultation = () => {
  const [astrologers, setAstrologers] = useState([]);
  const [selectedSpecialty, setSelectedSpecialty] = useState("");
  const [selectedAstrologer, setSelectedAstrologer] = useState(null);
  const [showBooking, setShowBooking] = useState(false);
  const [bookingDateTime, setBookingDateTime] = useState("");
  const [userBookings, setUserBookings] = useState([]);
  const [showBookings, setShowBookings] = useState(false);
  const { showAlert } = useContext(AlertContext);
  useEffect(() => {
    fetchAstrologers();
    fetchUserBookings();
  }, []);

  const fetchAstrologers = async () => {
    try {
      const response = await axios.get("https://back.varankal.com/api/astrologers/all");
      setAstrologers(response.data || []);
    } catch (error) {
      console.error("Error fetching astrologers:", error);
    }
  };

  const fetchUserBookings = async () => {
    try {
      const response = await axios.get("https://back.varankal.com/api/bookings/user-bookings", {
        withCredentials: true,
      });
      setUserBookings(response.data || []);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  };

  const handleBooking = (astrologer) => {
    setSelectedAstrologer(astrologer);
    setShowBooking(true);
  };

  const handleConfirmBooking = async () => {
    if (!selectedAstrologer || !bookingDateTime) {
      showAlert("Please select a date & time.", "error");
      return;
    }

    try {
      const response = await axios.post(
        "https://back.varankal.com/api/bookings/book",
        { astrologerId: selectedAstrologer._id, dateTime: bookingDateTime },
        { withCredentials: true }
      );

      alert(response.data.message);
      setShowBooking(false);
      fetchUserBookings();
    } catch (error) {
      console.error("Error booking astrologer:", error.response?.data || error.message);
      showAlert("Failed to book astrologer. Please try again.", "error");
    }
  };

  const toggleBookings = () => {
    setShowBookings(!showBookings);
  };

  const filteredAstrologers = selectedSpecialty
    ? astrologers.filter((astro) => astro.expertise?.includes(selectedSpecialty))
    : astrologers;

  return (
    <>
      <MainNavbar />
      <div className="astro-container">
        <h2 className="astro-title">🔮 Horoscope & Astrology Consultation</h2>
        <p className="astro-subtitle">Consult live astrologers online for marriage compatibility.</p>

        <div className="filter-container">
          <label>Filter by Specialty: </label>
          <select onChange={(e) => setSelectedSpecialty(e.target.value)}>
            <option value="">All Specialties</option>
            <option value="Vedic Astrology">Vedic Astrology</option>
            <option value="Marriage Compatibility">Marriage Compatibility</option>
            <option value="Palm Reading & Tarot">Palm Reading & Tarot</option>
          </select>
        </div>

        <div className="astro-list">
          {filteredAstrologers.length > 0 ? (
            filteredAstrologers.map((astrologer) => (
              <div key={astrologer._id} className="astro-card">
                <FaUser className="astro-icon" />
                <h3>{astrologer.name}</h3>
                <p>Specialty: {astrologer.expertise || "Not Specified"}</p>
                <p>Phone: {astrologer.phone || "N/A"}</p>
                <p>Experience: {astrologer.experience || "N/A"} years</p>
                <p>
                  <FaStar className="star-icon" /> {astrologer.rating || "N/A"} ({astrologer.reviews || 0} reviews)
                </p>
                <p className={astrologer.available ? "status-available" : "status-busy"}>
                  {astrologer.available ? "✅ Available" : "⏳ Busy"}
                </p>
                <button className="astro-btn1" onClick={() => handleBooking(astrologer)}>
                  <FaRegCalendarAlt /> Book Appointment
                </button>
              </div>
            ))
          ) : (
            <p>No astrologers found.</p>
          )}
        </div>

        {showBooking && selectedAstrologer && (
          <div className="popup-overlay" onClick={() => setShowBooking(false)}>
            <div className="popup" onClick={(e) => e.stopPropagation()}>
              <button className="popup-close-btn887" onClick={() => setShowBooking(false)}>×</button>
              <h3>Book an Appointment with {selectedAstrologer.name}</h3>
              <label>Select Date & Time:</label>
              <input
                type="datetime-local"
                onChange={(e) => {
                  setBookingDateTime(e.target.value);
                  e.target.blur(); // ✅ This will close the calendar after selection
                }}
              />

              <div className="popup-buttons">
                <button onClick={handleConfirmBooking}>Confirm Booking</button>
              </div>
            </div>
          </div>
        )}

        <button className="my-bookings-btn" onClick={toggleBookings}>
          <FaCalendarCheck /> My Bookings
        </button>

        {showBookings && (
          <div className="bookings-containerC33">
            <div className="bookings-header">
              <h3>📅 My Bookings</h3>
              <button className="popup-close-btn" onClick={toggleBookings}>×</button>
            </div>
            {userBookings.length > 0 ? (
              userBookings.map((booking) => (
                <div key={booking._id} className="booking-cardC33">
                  <h4>{booking.astrologerId?.name || "Astrologer"}</h4>
                  <p>Specialty: {booking.astrologerId?.expertise || "N/A"}</p>
                  <p>📅 {new Date(booking.dateTime).toLocaleString()}</p>
                  <p>Status: {booking.status}</p>
                </div>
              ))
            ) : (
              <p>No bookings found.</p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default AstrologyConsultation;
